// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1b32O","label":"SetPasswdForm_label__2xwfV"};